import { topicItems } from '@/mocks/home';

export default function SectionTopics() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              热门话题
            </h2>
          </div>

          <div className="flex flex-wrap gap-2 md:gap-3">
            {topicItems.map((topic) => (
              <a
                key={topic.id}
                href="#topics"
                className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/60 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  #{topic.name}
                </span>
                <span className="text-[10px] text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded-full">
                  {topic.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}